import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import Button from 'components/Button';
import localeUtils from 'utils/LanguageLocale';
import BundleWidgetEN from 'components/ProductPage/PdpBundling/BundleWidget/locales/BundleWidget_en_US';
import BundleWidgetFR from 'components/ProductPage/PdpBundling/BundleWidget/locales/BundleWidget_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(BundleWidgetEN, BundleWidgetFR);

const AddAllButton = ({ disabled }) => {
    return (
        <Button
            variant='primary'
            disabled={disabled}
            aria-disabled={disabled}
        >
            {getText('addAllToBasket')}
        </Button>
    );
};

export default wrapFunctionalComponent(AddAllButton, 'AddAllButton');
